import { __extends } from "tslib";
import { ShaderCodeNode } from "./shaderCodeNode.js";
/** @hidden */
var ShaderCodeConditionNode = /** @class */ (function (_super) {
    __extends(ShaderCodeConditionNode, _super);
    function ShaderCodeConditionNode() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ShaderCodeConditionNode.prototype.process = function (preprocessors, options) {
        for (var index = 0; index < this.children.length; index++) {
            var node = this.children[index];
            if (node.isValid(preprocessors)) {
                return node.process(preprocessors, options);
            }
        }
        return "";
    };
    return ShaderCodeConditionNode;
}(ShaderCodeNode));
export { ShaderCodeConditionNode };
//# sourceMappingURL=shaderCodeConditionNode.js.map